// state
const state = {
  stationsGroundGis: null,
  stationsIncidenceGis: null,
  stationsIrrigationGis: null,
  stationsIrrigationContadoresGis: null,
  stationsIrrigationElectrovalvulasGis: null,
  stationsCo2AbsorptionGis: null,
  stationsGeneralInfoGis: null,
  districtsAndParks: null,
  polygonParks: null,
  layers: {
    ground: ['ground', 'UPDATE_STATIONS_GROUND_GIS'],
    incidence: ['incidence', 'UPDATE_STATIONS_INCIDENCE_GIS'],
    generalInfo: ['generalInfo', 'UPDATE_STATIONS_GENERALINFO_GIS'],
    irrigation: ['irrigation', 'UPDATE_STATIONS_IRRIGATION_GIS'],
    contadores: ['irrigation', 'UPDATE_STATIONS_IRRIGATION_CONTADORES_GIS', 'meterBox'],
    electrovalvulas: ['irrigation', 'UPDATE_STATIONS_IRRIGATION_ELECTROVALVULAS_GIS', 'irrigationValve']
  }
}
/*
ground: ['ground', 'UPDATE_STATIONS_GROUND_GIS'],
incidence: ['incidence', 'UPDATE_STATIONS_INCIDENCE_GIS'],
irrigation: ['irrigation', 'UPDATE_STATIONS_IRRIGATION_GIS'],
co2Absorption: ['co2Absorption', 'UPDATE_STATIONS_CO2ABSOROPTION_GIS']
*/
// getters
const getters = {
  getStationsGroundGisData (state) {
    return state.stationsGroundGis
  },
  getStationsIncidenceGisData (state) {
    return state.stationsIncidenceGis
  },
  getStationsIrrigationContadoresGisData (state) {
    return state.stationsIrrigationContadoresGis
  },
  getStationsIrrigationGisData (state) {
    return state.stationsIrrigationGis
  },
  getStationsIrrigationElectrovalvulasGisData (state) {
    return state.stationsIrrigationElectrovalvulasGis
  },
  getStationsCo2AbsorptionGisData (state) {
    return state.stationsCo2AbsorptionGis
  },
  getStationsGeneralInfoGisData (state) {
    return state.stationsGeneralInfoGis
  },
  getDistrictsAndParksData (state) {
    return state.districtsAndParks
  },
  getPolygonParksData (state) {
    return state.polygonParks
  }
}

// actions
const actions = {
  // Update Data Gis
  getParksGis ({ commit, state }, data) {
    const store = this
    if (data !== undefined) {
      state.stationsAirGis = null
      let dataService = {
        method: 'GET',
        endpoint: '/api/dashboard/environmentGis',
        data: null,
        params: {
          type: data[0],
          country: 'ES',
          region: 'ES-GC',
          city: 'ES LPA'
        },
        mutation: data[1]
      }
      store.dispatch('callService', dataService)
    }
  },
  getIrrigationsGis ({ commit, state }, data) {
    const store = this
    if (data !== undefined) {
      state.stationsAirGis = null
      let dataService = {
        method: 'GET',
        endpoint: '/api/dashboard/environmentGis',
        data: null,
        params: {
          type: data[0],
          category: data[2],
          country: 'ES',
          region: 'ES-GC',
          city: 'ES LPA'
        },
        mutation: data[1]
      }
      store.dispatch('callService', dataService)
    }
  },
  getDistritcsAndParks ({ commit, state }, data) {
    const store = this
    state.calendarData = null
    let dataService = {
      method: 'GET',
      endpoint: '/api/parksAndGardens/districts',
      data: null,
      params: {
        country: 'ES',
        region: 'ES-GC',
        city: 'ES LPA',
        queryMethod: 'queryDistrictWithParks'
      },
      mutation: 'UPDATE_DISTRICTS_AND_PARKS'
    }
    store.dispatch('callService', dataService)
  },
  getPolygonParks ({ commit, state }) {
    const store = this
    let dataService = {
      method: 'GET',
      endpoint: '/api/parksAndGardens/parks',
      data: null,
      params: {
        country: 'ES',
        region: 'ES-GC',
        city: 'ES LPA',
        queryMethod: 'queryCityParksWithGeometry'
      },
      mutation: 'UPDATE_POLYGON_PARKS'
    }
    store.dispatch('callService', dataService)
  },
  // Update All Stations Gis
  getAllStationsParks ({ commit, state }) {
    const store = this
    // GIS
    store.dispatch('getParksGis', state.layers.generalInfo)
    store.dispatch('getParksGis', state.layers.ground)
    store.dispatch('getParksGis', state.layers.incidence)
    store.dispatch('getIrrigationsGis', state.layers.contadores)
    store.dispatch('getIrrigationsGis', state.layers.electrovalvulas)
    // POLYGON
    store.dispatch('getPolygonParks')
  }
}

// mutations
const mutations = {
  UPDATE_STATIONS_GROUND_GIS (state, data) {
    state.stationsGroundGis = data
  },
  UPDATE_STATIONS_INCIDENCE_GIS (state, data) {
    state.stationsIncidenceGis = data
  },
  UPDATE_STATIONS_IRRIGATION_CONTADORES_GIS (state, data) {
    state.stationsIrrigationContadoresGis = data
  },
  UPDATE_STATIONS_IRRIGATION_ELECTROVALVULAS_GIS (state, data) {
    state.stationsIrrigationElectrovalvulasGis = data
  },
  UPDATE_STATIONS_GENERALINFO_GIS (state, data) {
    state.stationsGeneralInfoGis = data
  },
  UPDATE_STATIONS_CO2ABSOROPTION_GIS (state, data) {
    state.stationsCo2AbsorptionGis = data
  },
  UPDATE_DISTRICTS_AND_PARKS (state, data) {
    state.districtsAndParks = data
  },
  UPDATE_POLYGON_PARKS (state, data) {
    state.polygonParks = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/dashboardParks.js